export default $payment => {
	const test = () => $payment

	return { test }
}
